var LoginLayoutComponent = /** @class */ (function () {
    function LoginLayoutComponent() {
    }
    return LoginLayoutComponent;
}());
export { LoginLayoutComponent };
